<template>
  <router-view />
</template>

<script setup>
// App shell, no logic needed
</script>

<style>

        /* 全局样式 */
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
        }
        
        body {
            background: linear-gradient(135deg, #6491DE 0%, #073D7F 100%);
            min-height: 100vh;
            color: #1a1f36;
            line-height: 1.5;
        }
        
        .container1 {
            width: 80%;
            /* max-width: 1600px; */
            margin: 0 auto;
            padding: 0 20px;
        }
        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;
        }
        
        button {
            cursor: pointer;
            border: none;
        }
        
        .btn {
            display: inline-block;
            width: 100%;
            padding: 12px 24px;
            border-radius: 4px;
            font-weight: 500;
            font-size: 16px;
            transition: all 0.2s ease;
            text-align: center;
        }
        
        .btn-primary {
            background-color: #6491DE;
            color: white;
        }

        .btn-primary:hover {
            background-color: #073D7F;
        }

        .btn-link {
            background: none;
            color: #6491DE;
            padding: 0;
            font-size: 14px;
        }
        
        .btn-link:hover {
            text-decoration: underline;
        }
        
        .form-group {
            margin-bottom: 20px;
        }
        
        label {
            display: block;
            margin-bottom: 8px;
            font-weight: 500;
            font-size: 14px;
        }
        
        input {
            width: 100%;
            padding: 12px 16px;
            border: 1px solid #d1d5db;
            border-radius: 4px;
            font-size: 16px;
            transition: border-color 0.2s ease;
        }
        
        input:focus {
            outline: none;
            border-color: #6491DE;
            box-shadow: 0 0 0 3px rgba(100, 145, 222, 0.1);
        }
        
        .error-message {
            color: #dc2626;
            font-size: 14px;
            margin-top: 4px;
        }
        
        .text-center {
            text-align: center;
        }
        
        .mt-4 {
            margin-top: 16px;
        }
        
        .mt-6 {
            margin-top: 24px;
        }
        
        .mb-6 {
            margin-bottom: 24px;
        }
        
        /* 登录页面样式 */
        .login-container {
            min-height: 100vh;
            display: flex;
            flex-direction: column;
        }
        
        .login-header {
            padding: 24px 0;
        }
        
        /* .logo {
            width: 400px;
            height: 80px;
        } */
        
        .login-card {
            background-color: white;
            border-radius: 8px;
            box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
            padding: 40px;
            min-width: 500px;
            max-width: 500px;
            margin: 0 auto;
            width: 500px;
        }
        
        .login-title {
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 8px;
        }
        
        .login-subtitle {
            color: #64748b;
            margin-bottom: 32px;
        }
        
        .separator {
            display: flex;
            align-items: center;
            margin: 24px 0;
        }
        
        .separator::before,
        .separator::after {
            content: "";
            flex: 1;
            height: 1px;
            background-color: #e2e8f0;
        }
        
        .separator span {
            padding: 0 12px;
            font-size: 14px;
            color: #64748b;
        }
        
        .footer-links {
            display: flex;
            justify-content: center;
            gap: 24px;
            margin-top: 40px;
            color: #e2e8f0;
        }
        
        .footer-link {
            color: #e2e8f0;
            font-size: 14px;
            text-decoration: none;
        }
        
        .footer-link:hover {
            text-decoration: underline;
        }
        
        /* 仪表盘样式 */
        .dashboard-container {
            min-height: 100vh;
            background-color: #f7f9fc;
        }
        
        .dashboard-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px 24px;
            background-color: #ffffff;
            border-bottom: 1px solid #e2e8f0;
        }
        
        .logo-container .stripe-logo {
            width: 40px;
            height: 40px;
            fill: #6491DE;
        }
        
        .user-menu {
            display: flex;
            align-items: center;
        }
        
        .logout-button {
            background-color: transparent;
            color: #6491DE;
            border: 1px solid #6491DE;
            border-radius: 4px;
            padding: 8px 16px;
            font-size: 14px;
            font-weight: 500;
            transition: all 0.2s ease;
        }

        .logout-button:hover {
            background-color: rgba(100, 145, 222, 0.05);
        }
        
        .dashboard-content {
            padding: 40px;
        }
        
        .dashboard-content h1 {
            font-size: 28px;
            font-weight: 600;
            margin-bottom: 16px;
            color: #1a1f36;
        }
        
        .dashboard-content p {
            font-size: 16px;
            color: #64748b;
        }
        
        /* 忘记密码页面样式 */
        .forgot-password-container {
            min-height: 100vh;
            display: flex;
            flex-direction: column;
        }
        
        .back-link {
            display: inline-flex;
            align-items: center;
            color: #6491DE;
            text-decoration: none;
            margin-bottom: 32px;
            font-size: 14px;
        }
        
        .back-link i {
            margin-right: 8px;
        }
        
        .back-link:hover {
            text-decoration: underline;
        }

        /* Mobile Responsiveness - Only apply on small screens */
        @media (max-width: 768px) {
            .container {
                padding: 0 20px;
            }

            .container1 {
                width: 100%;
                padding: 0 20px;
            }

            /* Login Page Mobile */
            .login-header {
                padding: 20px 0;
            }

            .login-card {
                min-width: auto !important;
                max-width: 500px !important;
                width: 90vw !important;
                padding: 40px !important;
                border-radius: 8px !important;
                box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1) !important;
                margin: 0 auto !important;
            }

            .footer-links {
                flex-wrap: wrap;
                gap: 16px;
                margin-top: 24px;
                padding: 0 20px;
            }

            /* Form Elements Mobile - Prevent iOS zoom */
            input {
                font-size: 16px;
                padding: 12px 16px;
            }

            .btn {
                padding: 14px 24px;
                font-size: 16px;
            }
        }

        @media (max-width: 480px) {
            .container {
                padding: 0 16px;
            }

            .container1 {
                padding: 0 16px;
            }

            .login-card {
                min-width: auto !important;
                width: 90vw !important;
                max-width: 500px !important;
                padding: 40px !important;
            }

            .login-title {
                font-size: 22px;
            }

            .logo .title {
                font-size: 26px !important;
            }

            .logo h3 {
                font-size: 15px;
            }

            .footer-links {
                flex-direction: column;
                gap: 14px;
                text-align: center;
                padding: 0 16px;
            }

            .footer-link {
                font-size: 13px;
            }
        }
</style>
